import { v1 as uuidv1 } from 'uuid';

export default function CreateGUID() {
    return uuidv1().replace(new RegExp("-", 'g'), "").toUpperCase()
}